import React, { FC } from 'react';
import { CSS } from '@dnd-kit/utilities';
import { useSortable } from '@dnd-kit/sortable';

import SContentCard, { SContentCardProps } from 'Components/structural/SContentCard/SContentCard';
import { type PartialContentForCampaignForm } from 'Store/entities/activity/activity.type';

export type DraggableContentCardProps = {
  dragId: number | string;
  draggable: boolean;
  content: PartialContentForCampaignForm;
  contentCardProps: SContentCardProps;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
};

export const DraggableContentCard: FC<DraggableContentCardProps> = ({
  dragId,
  draggable,
  content,
  contentCardProps,
  onClick,
}) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: dragId,
    disabled: !draggable,
    data: { content },
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div ref={setNodeRef} onClick={onClick} style={style} {...attributes} {...listeners}>
      <SContentCard {...contentCardProps} />
    </div>
  );
};
